import Footer from "./Component/Footer";
import MenuBar from "./Component/MenuBar";
import PageBanner from './Component/PageBanner';
import Sidebar from './Component/Sidebar';
const ActivityCalendar = () => {
    return (
        <>

            <MenuBar />
            <Sidebar />
            {/* <!-- Page Banner Section --> */}
            <PageBanner title="Activity Calendar" />

            {/* <!--End Banner Section --> */}

            {/* <!--FAQs Section--> */}
            <section className="faq-section">
                <div className="auto-container">

                    <div className="row clearfix">
                        <div className="offset-1">


                        </div>

                        <div className="col-md-10 offset 1">
                            <img src="https://yugalkunj.org/images/ykcalender.jpg" className="img-round " style={{ border: '1px solid #ccc' }} alt="yk calender" />

                            {/* <!-- <iframe id="gcalendar_frame" src="https://www.google.com/calendar/embed?showTitle=1&amp;showNav=1&amp;showDate=1&amp;showPrint=1&amp;showTabs=1&amp;showCalendars=0&amp;showTz=1&amp;mode=MONTH&amp;wkst=2&amp;bgcolor=%23FFFFFF&amp;hl=&amp;ctz=America/New_York&amp;height=500&amp;src=i4ot1nkv9bsnvk34bikit77vks@group.calendar.google.com&amp;color=%23A32929&amp;src=i4ot1nkv9bsnvk34bikit77vks@group.calendar.google.com&amp;color=%23B1440E" width="100%" height="500" align="top" frameborder="0" className="gcalendar"> </iframe> -->  */}
                        </div>




                    </div>


                </div>
            </section>






            <Footer />


        </>


    )



}

export default ActivityCalendar;
